import { DatePipe } from '@angular/common';
import { Component, Input, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import moment from 'moment';
import { DataService } from 'src/app/services/data.service';
import { EntitiesServiceService } from '../../../../../services/entities-service.service';
import { ServicecallService } from 'src/app/services/servicecall.service';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-monotainer-history',
  templateUrl: './monotainer-history.component.html',
  styleUrls: ['./monotainer-history.component.css']
})
export class MonotainerHistoryComponent implements OnInit, OnDestroy {
  @Input() tabData: any;
  @Input() periodFilter: any;
  @Input() pageSize: any;
  @Input() refreshRate: any;
  @Input() genericFilter: any
  @ViewChild(MatSort, { static: false }) sort!: MatSort;
  @ViewChild(MatPaginator, { static: false }) paginator!: MatPaginator;

  masterMonotainerHistory: any = [];
  columnHeader: any = {
    'tagId': 'Tag ID', 'taggedTime': 'Tagged Time', 'destination': 'Destination', 'laneName': 'Lane', 'tat': 'TAT',
    'entryTime': 'Entry Time', 'exitTime': 'Exit Time', 'action': 'History'
  };
  isloader: boolean = true;
  timeLineData: any[] = [];
  timeLineEvent: string = 'new';

  // @Input() periodFilter: any;
  // @Input() pageSize: any;

  // startTime: any;
  // today: any = new Date();

  currentPage: number = 1;
  refreshTime: any = this._datePipe.transform(Date.now(), 'EEEE, MMMM d, y, h:mm:ss a zzzz');
  displayTimeLineDetails: any = {
    tagId: '',
    tat: '',
    duration: ''
  };
  pager: any = {};

  private _isError: boolean = false;
  private _today: any = new Date();
  private _subscription: Subscription;
  private _intervalTimer: any;
  private _timeZone: any;
  private _getMonotainerHistorySubscription: Subscription;

  constructor(private _service: EntitiesServiceService, private _datePipe: DatePipe, private _dataSer: DataService, private _sharedService: ServicecallService) {
    this._subscription = _dataSer.events.subscribe((res: any) => {
      if (res.name === 'siteChanged' || res.name === 'apiRefresh' || res.name === 'tagRefresh') {
        this._getMonotainerHistory(this.currentPage);
      }
    });
  }

  ngOnInit(): void {
    this._findRefreshTime();
  }

  ngOnChanges(): void {
    this._getMonotainerHistory(this.currentPage);
  }
  onPaginateChange(page: any) {
    this.currentPage = page;
    document.getElementById("launchScroll")?.scrollIntoView({ behavior: "smooth" });
    this._getMonotainerHistory(this.currentPage);
  }

  ngOnDestroy(): void {
    if (this._subscription) {
      this._subscription?.unsubscribe();
    }
    this._clearTimer();
    this._getMonotainerHistorySubscription?.unsubscribe();

  }


  private _findRefreshTime() {
    const timeZoneName = sessionStorage.getItem('selectedTimeZone');
    if (timeZoneName) {
      this._timeZone = (timeZoneName);
      const gmtOffsetString = this._dataSer.findgmtOffset(timeZoneName);
      this.refreshTime = this._datePipe.transform(Date.now(), 'EEEE, MMMM d, y, h:mm:ss a zzzz', gmtOffsetString);
    } else {
      this.refreshTime = this._datePipe.transform(Date.now(), 'EEEE, MMMM d, y, h:mm:ss a zzzz');
      const localTime = moment.tz.guess();
      this._timeZone = (localTime);
    }
  }
  private _refreshApi() {
    if (+this.refreshRate) {
      this._clearTimer();
      this._intervalTimer = setInterval(() => {
        this._getMonotainerHistory(this.currentPage);
        this._findRefreshTime();
      }, +this.refreshRate);
      this._isError = false;
    }
  }

  private _clearTimer() {
    if (this._intervalTimer) {
      clearInterval(this._intervalTimer);
    }
  }

  private _getTimelineConfigurations(key: string) {
    const config = this._sharedService.getConfiguration('cnpTimeline')?.['cnpTimeline'];
    return config?.find(e => e.key == key);
  }

  private _getMonotainerHistory(pageNo: any) {
    this.masterMonotainerHistory = [];
    const payload = {
      id: this.tabData?.entityId,
      offset: pageNo,
      limit: this.genericFilter?.pageSize,
      from: this._datePipe.transform(this.genericFilter?.startTime, 'yyyy-MM-ddTHH:mm:ssZZ'),
      to: this._datePipe.transform(this.genericFilter?.endTime ? this.genericFilter?.endTime : Date.now(), 'yyyy-MM-ddTHH:mm:ssZZ'),
    };
    this.isloader = true;
    this._getMonotainerHistorySubscription = this._service.getMonotainerHistory(payload).subscribe({
      next: (resp: any) => {
        if (resp?.data?.length) {
          this.masterMonotainerHistory = [...resp?.data];
          this.masterMonotainerHistory.map((item: any) => {
            item.laneName = item.zone ? item.zone.map((elem: any) => { return elem?.name?.toString() })?.toString() : null;
            item.originalEntryTime = item?.entryTime;
            item.originalExitTime = item?.exitTime;
            item.entryTime = this._datePipe.transform(item?.entryTime, 'hh:mm aaa');
            item.exitTime = this._datePipe.transform(item?.exitTime, 'hh:mm aaa');
            item.taggedTime = this._datePipe.transform(item?.taggedTime, 'dd MMM yyyy hh:mm a');
          });
        } else {
          this.masterMonotainerHistory = [];
        }
        if (resp?.pageInfo) {
          this.pager = { ...resp?.pageInfo };
          this.pager['pageSize'] = 10;
          this.pager['startPage'] = resp?.pageInfo['pages'][0];
          this.pager['endPage'] = resp?.pageInfo['pages'][this.pager['pages'].length - 1];
          this.pager['isLastPage'] = resp?.pageInfo['endPage'];
        }
        this.isloader = false;
        // this._refreshApi();
      }, error: () => {
        this._isError = true;
        this.isloader = false;
      }
    });
  }

  tableAction(event: any) {
    if (event.type === 'export') {
      const fileType = event.item;
      const fields = this._sharedService.getConfiguration('exportGenericConfig') ? this._sharedService.getConfiguration('exportGenericConfig')?.monotainerHistory : null;
      const reqParam = {
        from: this._datePipe.transform(this.genericFilter?.startTime, 'yyyy-MM-ddTHH:mm:ssZZ'),
        to: this._datePipe.transform(this.genericFilter?.endTime ? this.genericFilter?._endTime : Date.now(), 'yyyy-MM-ddTHH:mm:ssZZ'),
        timezone: sessionStorage.getItem('selectedTimeZone') ? sessionStorage.getItem('selectedTimeZone') : moment.tz.guess(),
        exportFormat: fileType,
        exportFilename: "Device Data",
        category: "monotainer",
        siteId: this._sharedService.getSiteId(),
        fields: [...fields]
      }
      this._sharedService.commonExport(fileType, reqParam, 'monotainerExport', 'Export_Monotainer_History', 'history', this.tabData?.entityId);
    } else {
      if (this.timeLineData?.length) {
        this.timeLineData = [];
      }
      this.displayTimeLineDetails = {
        tagId: event?.item?.tagId,
        tat: event?.item?.tat,
        duration: event?.item?.lifecycleDuration,
        destination: event?.item?.destination,
        taggedBy: event?.item?.taggedBy
      };
      this.timeLineData = [...event?.item?.timeline]?.reverse();
      this.timeLineData?.map((item: any) => {
        // if (item.action?.toLowerCase() === "mismatch") {
        //   item.action = "Misplaced";
        // }
        item['color'] = this._getTimelineConfigurations(item?.action)?.color;
        item['name'] = this._getTimelineConfigurations(item?.action)?.name;
      });
      // if (event?.item?.originalEntryTime) {
      //   this.timeLineData?.push({
      //     at: event?.item?.originalEntryTime,
      //     action: "entry"
      //   });
      // }
      // if (event?.item?.originalExitTime) {
      //   this.timeLineData?.push({
      //     at: event?.item?.originalExitTime,
      //     action: "exit"
      //   });
      // }
      // this.timeLineData?.sort((a, b) => (a.at > b.at ? 1 : -1));
      // const insideData = this.timeLineData.filter((item: any) => item.action === 'inside' && !item.isValid);
      // if (insideData?.length) {
      //   insideData.forEach(element => {
      //     const index = this.timeLineData?.indexOf(element);
      //     this.timeLineData.splice(index + 1, 0, {
      //       at: element?.at,
      //       action: "Misplaced"
      //     });
      //   });
      // }
      // if (insideData) {
      //   const index = this.timeLineData?.indexOf(insideData);
      //   this.timeLineData.splice(index + 1, 0, {
      //     at: insideData?.at,
      //     action: "Misplaced"
      //   });
      //   // this.timeLineData?.push({
      //   //   at: this.datePipe.transform(new Date(insideData?.at).setSeconds(new Date(insideData?.at).getSeconds() + 1), 'yyyy-MM-ddTHH:mm:ssZ'), //here, need to increase seconds of (insideData.at) by 1.
      //   //   action: "Misplaced"
      //   // });
      // }
    }

  }

  closeDrawer() {
    this._dataSer.broadcast('timeLineClosed');
  }
}
